import { network } from 'services/network';

import { QueryParams } from 'api/queries/getRunRateAnalysisBreakdown.query';

export const getRunRateAnalysisBreakdown = (params: QueryParams) => {
    return network.post('api/bo/getRunRateAnalysisBreakdown', params).then((response) => {
        return response.data;
    });
};
